import { createContext, useContext } from 'react';

import type { CustomTestEditContextValue } from 'pages/custom_tests_v1/components/custom_test_edit/CustomTestEdit';

export const CustomTestEditContext = createContext({} as CustomTestEditContextValue);
CustomTestEditContext.displayName = 'CustomTestEditContext';

export const useCustomTestEdit = () => useContext(CustomTestEditContext);